import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { IMatbc001 } from "../interface";
import ModalChartMatrizBcg, { IMatrizBcgChartRef } from "./modalChart";

import SpreadSheetMatrizBcg from "./spreadsheet";

export interface IRefContentMatrizBcg{
  loadData: (analysis: IMatbc001) => void;
}

const ContentMatrizBcg: React.ForwardRefRenderFunction<IRefContentMatrizBcg> = (_, ref) => {

	const { translate } = useTranslation();
	const refModalChart = useRef<IMatrizBcgChartRef>(null);
	const [ selectedMatrizBcg, setSelectedMatrizBcg] = useState<IMatbc001 | null>(null);


	const loadData = async (analysis: IMatbc001) => {
		setSelectedMatrizBcg(analysis);
	};

	useImperativeHandle(ref, () => ({
		loadData
	}));

	return (
		<>
			<RCCGrid
				container 
				item
				justifyContent="space-between"
				xs={12}
			>
				<Title color="purple" size="xl">
					{selectedMatrizBcg?.mac001Titulo}
				</Title>
				<RCCGrid container item xs={4} justifyContent="flex-end">
					{selectedMatrizBcg && (
						<>
							<RCCTooltip
								text={translate("Visualizar Gráfico")}
								position="leftEnd"
								color="grey"
							>
								<RCCButton
									icon={{name: "chartBar", color: "#FFF", size: 18}}
									color="grey"
									layout="isRounded"
									onClick={(e) => {e.stopPropagation();  refModalChart.current?.openModalChart(selectedMatrizBcg.mac001Id, selectedMatrizBcg.mac001Titulo); }}
									size="md"
								/>
							</RCCTooltip>
						</>
					)}
					
				</RCCGrid>
			</RCCGrid>
			
			{
				selectedMatrizBcg &&
				<>
					{selectedMatrizBcg?.mac001Descricao &&
					<RCCGrid
						container
						item
						alignItems="center"
					>
						<Title color="grey" size="xs">
							{selectedMatrizBcg?.mac001Descricao}
						</Title>
					</RCCGrid>
					}

					{
						selectedMatrizBcg.mac001Id &&
						<RCCGrid style={{padding: 10}}>
							<SpreadSheetMatrizBcg 
								selectedMatrizBcg={selectedMatrizBcg}
							/>
						</RCCGrid>
					}					
				</>
			}

			<ModalChartMatrizBcg
				ref={refModalChart}
			/>
		</>
	);
};


export default React.forwardRef(ContentMatrizBcg);
